import {
  Box,
  Stack,
  Theme,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from "@mui/material";
import { INSIGHT_TABLE_SWITCH_VALUES } from "../../../constants";
import { useAtom } from "jotai";
import { baseAtom } from "../../../stores/jotai/base";
interface InsightArtifactTypeToggleProps {
  handleToggle: (
    event: React.MouseEvent<HTMLElement>,
    newSelected: string[]
  ) => void;
  selectedTab: string[];
  component: string;
  style?: React.CSSProperties;   
  insight?: string;            
}
const ToggleButtonGroupStyles = (theme: Theme) => ({
  backgroundColor: theme.custom.disabledColor,
  borderRadius: "4px",
  height: "38px",
  "& .MuiToggleButtonGroup-grouped": {
    margin: "7px",
    padding: "0 8px",
    textTransform: "capitalize",
    border: "1px solid transparent",
    fontSize: "13px",
    backgroundColor: "white",
    ":hover": {
      backgroundColor: "white",
      color:"#1976D2",
    },
    "&.Mui-selected": {
      color: theme.custom.mainButtonHighlight,
      borderColor: "#1976D2",
      "&, :hover": {
        backgroundColor: theme.custom.white,
      },
    },
    "&:not(:first-of-type)": {
      borderRadius: "4px",
      marginLeft: "2px",
    },
    "&:first-of-type": {
      borderRadius: "4px",
      marginRight: "6px",
    },
    
  },
  "& .MuiToggleButtonGroup-grouped.Mui-selected + .MuiToggleButtonGroup-grouped.Mui-selected": {
    borderLeft: "1px solid #1976D2",
  },
});

const InsightArtifactTypeToggle: React.FC<InsightArtifactTypeToggleProps> = ({
  handleToggle,
  selectedTab,
  style={},
  insight,
  component,
}) => {
  const theme = useTheme();
  const [base, setBase] = useAtom(baseAtom);
  
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      sx={{
        fontSize: "16px",
        fontWeight: "600",
        backgroundColor: "white",
        ...style,
      }}
    >
      <Box>{insight ? insight : null}</Box>
      <Stack sx={{ marginLeft: "auto" }} direction="row" gap={0.5}>
        <ToggleButtonGroup
          size="small"
          onChange={handleToggle}
          value={selectedTab}
          sx={{
            ...ToggleButtonGroupStyles(theme),
          }}
        >
          {component !== "toolbar" && base.team?.isAiInsightGenerationEnabled && (
            <ToggleButton value={INSIGHT_TABLE_SWITCH_VALUES.ANALYSIS}>
              Analysis
            </ToggleButton>
          )}
          {component==="toolbar" ? (
            <ToggleButton value={INSIGHT_TABLE_SWITCH_VALUES.ANALYSIS}>
            { base.team?.isAiInsightGenerationEnabled ? "Analysis/Notes":"Notes"} 
            </ToggleButton>
          ) : (
            <ToggleButton value={INSIGHT_TABLE_SWITCH_VALUES.NOTES}>
              Notes
            </ToggleButton>
          )}

          <ToggleButton value={INSIGHT_TABLE_SWITCH_VALUES.TRANSCRIPT}>
            Transcript
          </ToggleButton>
          {component==="toolbar" ? (
            <ToggleButton value={INSIGHT_TABLE_SWITCH_VALUES.INSIGHT}>
              Insight
            </ToggleButton>
          ) : null}
        </ToggleButtonGroup>
      </Stack>
    </Stack>
  );
};

export default InsightArtifactTypeToggle;
